import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence, useScroll } from 'framer-motion';
import { FaArrowCircleUp } from "react-icons/fa"; // Updated Import

const BackToTop = () => {
    const [showButton, setShowButton] = useState(false);
    const { scrollY } = useScroll();

    useEffect(() => {
        return scrollY.on("change", (latest) => {
            // Shows button after scrolling 400px
            if (latest > 400) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        });
    }, [scrollY]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <AnimatePresence>
            {showButton && (
                <motion.div
                    className="back-to-top"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    transition={{ duration: 0.2 }}
                    onClick={scrollToTop}
                    style={{
                        position: 'fixed',
                        bottom: '30px',
                        right: '30px',
                        cursor: 'pointer',
                        zIndex: 1000,
                        fontSize: '300%', // Icon size
                        color: 'var(--dark)',     // Match your brand color
                        backgroundColor: 'var(--light)',
                        display: 'flex',
                        borderRadius: '50%',
                    }}
                >
                    <FaArrowCircleUp />
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default BackToTop;